import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router';
import styles from './AccountActions.module.scss';
import { Button, Modal } from 'esa-ui-library';
import { DELETE_ACCOUNT_TITLE, DELETE_ACCOUNT_MESSAGE, PERMISSIONS } from '../..';
import { debounce, useStore, BACKOFFICE_USERS_URL } from '../../../common';
import { AuthContext } from '../../../logic';

const AccountActions = (): JSX.Element => {
	const [modalOpened, setModalOpened] = useState(false);
	const [{ userId, isActive }, dispatch] = useStore();
	const { user, token } = useContext(AuthContext);
	const history = useHistory();

	const onAccountDelete = () => {
		dispatch('DELETE_ACCOUNT', token);
		onModalClose();
		debounce(() => history.replace(BACKOFFICE_USERS_URL.value), 3000);
	};

	const onAccountActivate = async () => {
		await dispatch('ACTIVATE_ACCOUNT', token);
		dispatch('USER_INIT', { token, id: userId });
	};

	const onAccountDeactivate = async () => {
		await dispatch('DEACTIVATE_ACCOUNT', token);
		dispatch('USER_INIT', { token, id: userId });
	};

	const onModalOpen = () => {
		setModalOpened(true);
	};

	const onModalClose = () => {
		setModalOpened(false);
	};

	const renderActions = () => (
		<>
			<span className={`${styles.ActivityIndicator} ${isActive ? styles.Active : ''}`}>
				Account {`${isActive ? '' : 'in'}active`}
			</span>
			{(user?.permissions?.isSuperAdmin || user?.permissions[PERMISSIONS.canDisableUser]) && !isActive && (
				<Button small title='Activate Account' onClick={onAccountActivate} />
			)}
			{(user?.permissions?.isSuperAdmin || user?.permissions[PERMISSIONS.canDisableUser]) && isActive && (
				<Button small title='Deactivate Account' onClick={onAccountDeactivate} />
			)}
			{(user?.permissions?.isSuperAdmin || user?.permissions[PERMISSIONS.canDeleteUser]) && (
				<Button
					small
					danger
					title='Delete Account'
					className={styles.DeleteAccount}
					onClick={onModalOpen}
					dataId='delete-account'
				/>
			)}
			{modalOpened && (
				<Modal
					danger
					title={DELETE_ACCOUNT_TITLE}
					submitLabel='Delete Account'
					onCancel={onModalClose}
					onSubmit={onAccountDelete}
				>
					{DELETE_ACCOUNT_MESSAGE}
				</Modal>
			)}
		</>
	);

	return userId ? renderActions() : <></>;
};

export { AccountActions };
